import React from 'react';
import { Select, Input, Button, Icon } from 'antd';
import {matchPhrases} from '../../../utils/search';
import {FilterType, OperatorType} from '../../../types/cube';
import _ from 'lodash';

export type SelectFilterPropsType = {
    placeholder: ?String;
    loadItems?: () => Promise<Array<{value: String, title: String}>>;
    selected?: Array<String> | Number;
    onChange: (values: Array<String> | Number, operator: OperatorType) => void;
    operator: OperatorType;
    onOperatorChange?: (value: OperatorType) => void;
    onDelete: () => void;
    style: React.StyleHTMLAttributes;
    context: Array<FilterType>;
    id: String;
    type: 'list' | 'number';
    max?: Number;
    min?: Number;
    units?: String;
}

export type SelectFilterStateType = {
    items: Array<{value: String, title: String}>,
    filteredItems: Array<{value: String, title: String}>,
    loaded: Boolean, loading: Boolean, error: Object
}

const OperatorSelect = (props: {
    text: string;
    value: OperatorType;
    onChange: (value: OperatorType) => void;
}) => {
    return <Select style={{minWidth: 120}} defaultValue="gt" onChange={props.onChange} value={props.value}>
        <Select.Option value="equals">{props.text} =</Select.Option>
        <Select.Option value="gt">{props.text} ≥</Select.Option>
        <Select.Option value="lt">{props.text} ≤</Select.Option>
    </Select>
};

export default class SelectFilter extends React.Component<SelectFilterPropsType> {
    state: SelectFilterStateType = {
        items: [],
        filteredItems: [],
        loaded: false,
        loading: false,
        error: null
    }
    selectRef = React.createRef()
    componentDidMount() {
        if (this.props.type === 'list') {
            this.setState({items: [], loaded: false, loading: true});
            this.props.loadItems()
                .then(items => {
                    this.setState({
                        items, loaded: true, loading: false
                    }, () => this.filterItems())
                })
                .catch(error => this.setState({loaded: false, loading: false, error}))
        }
    }
    onSelect() {
        this.selectRef.current.blur();
    }
    onChange(values, operator) {
        this.props.onChange(values, operator);
    }
    componentDidUpdate(prevProps) {
        // const oldContextValues = _.flatten(_.values(prevProps.context).map(v => v.values));
        // const newContextValues = _.flatten(_.values(this.props.context).map(v => v.values));
        if (!_.isEqual(this.props.context, prevProps.context)) {
            this.filterItems()
        }
    }
    filterItems(value) {
        const {context, id, selected} = this.props;
        const otherFilters = context.filter(c => c.dimension !== id && c.values.length > 0);
        this.setState({
            filteredItems: [...this.state.items.filter(i => {
                // return !value || matchPhrases(value, i.title);
                var match = true;
                otherFilters.forEach(of => {
                    const otherDimension = of.dimension.split('.')[1];
                    if (i[otherDimension]) {
                        if (!of.values.includes(i[otherDimension])) {
                            match = false;
                        }
                    }
                })
                if (!value || matchPhrases(value, i.title)) {
                    return match;
                }
                return false;
            })].sort((a, b) => {
                if (selected.includes(a.value)) {
                    return -1;
                }
                if (selected.includes(b.value)) {
                    return 1;
                }
                return 0;
            }).splice(0, 40)
        })
    }
    render() {
        const { placeholder, type, selected, operator, min, max, units } = this.props;
        const {filteredItems, loading} = this.state;
        return <Input.Group compact style={{...this.props.style, display: 'flex'}}>
            {type === 'list' && <Select
                value={this.props.selected}
                onSelect={this.onSelect.bind(this)}
                ref={this.selectRef}
                style={{ minWidth: 300 }} 
                placeholder={placeholder} 
                mode="multiple"
                loading={loading}
                disabled={loading}
                showArrow
                onChange={values => this.onChange(values, operator)}
                filterOption={() => true}
                onSearch={this.filterItems.bind(this)}
            >
                {filteredItems.map(i => <Select.Option 
                    value={i.value} 
                    key={i.value}
                    title = {i.title}
                >
                    {i.title}
                </Select.Option>)}
            </Select>}
            {type === 'number' && <Input 
                value={selected[0] || min || 0}
                suffix={units}
                onChange={e => {
                    try {
                        let value = parseFloat(e.target.value);
                        if (max && value > max) value = max;
                        if (min && value < min) value = min;
                        this.props.onChange([value], operator);
                    } catch {
                        console.warn('Not ok');
                    }
                }}
                style={{width: 100 + 60 + 100}}
                addonBefore={<OperatorSelect 
                    text={placeholder} value={operator} 
                    onChange={op => this.props.onChange(selected, op)}
                />}
            />}
            {this.props.onDelete && <Button onClick={this.props.onDelete}>
                <Icon type="delete" />
            </Button>}
        </Input.Group>
    }
}